<template>
  <div class="Verification">
    <div class="head">
      <van-icon name="arrow-left" class="black_arrow" @click="$router.go(-1)"/>
      <div class="title">重置密码</div>
    </div>
    <div class="EditingArea">
      <ul>
        <li>
          <van-field
            v-model="phone"
            center
            clearable
            :border="false"
            @focus="inputFocus"
            use-button-slot
            placeholder="请输入手机号/邮箱"
          />
        </li>
        <li class="authcodeInputWrapper">
          <van-field
            v-model="Verification"
            class="VerificationStyle fl"
            clearable
            placeholder="请输入验证码"
            :border="false"
          />

          <div class="getVerificationStyle fr" @click="postAccountGetAuthCode" :style="{color:Countdown>0? '#BBBBBB':'#333333'}">
            {{ VerificationStatus }}
          </div>

          <div class="clear"></div>
        </li>
      </ul>
    </div>
    <div class="OperatingSpace">
      <van-button
        round type="info"
        @click="verifyUser"
        :class="this.phone ? 'van-button--info' : 'noneVanButton'"
      >下一步</van-button>
    </div>
  </div>
</template>
<script>
const isPhone = /^1(?:3[0-9]|4[5-9]|5[0-9]|6[12456]|7[0-8]|8[0-9]|9[0-9])[0-9]{8}$/;
const isEmail = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
export default {
  name: 'verification',
  data () {
    return {
      Countdown: 0,
      countdownInterval: null,
      phone: null,
      Verification: null
    }
  },
  computed: {
    VerificationStatus () {
      if (this.Countdown) {
        return `重新获取 ${this.Countdown}s`
      } else {
        return '发送验证码'
      }
    }
  },
  created () {
    window.addEventListener('resize', this.inputFocus)
  },
  destroyed () {
    window.removeEventListener('resize', this.inputFocus)
  },
  mounted () {
    this.clientHeight = document.documentElement.clientHeight
  },
  methods: {
    verifyUser(){
      if(this.Verification.length != 6){
        this.$notify({ type: 'warning', message: '请输入6位验证码' })
        return
      }
      let data = {account:this.phone,authCode:this.Verification}
      this.$api.usercenter.checkAuthCode(data).then(res => {
        if(res.success){
          this.toRouter(`/resetPassword?a=${this.phone}&b=${this.Verification}`)
        }
      });
    },
    toRouter (path) {
      this.$router.push({ path })
    },
    inputFocus () {
      const height = document.documentElement.clientHeight
      if (this.clientHeight > height) {
        let vanField = document.querySelectorAll('.vanField')
        let total = vanField[0].offsetTop - 20
        document.body.scrollTop = total
      } else {
        document.body.scrollTop = 0
      }
      this.clientHeight = document.documentElement.clientHeight
    },
    postAccountGetAuthCode () {
      if (this.Countdown > 0 ) return
      let data = { account: this.phone,type:1 }
      if (isPhone.test(this.phone) || isEmail.test(this.phone)) {
        this.Countdown = 60
        this.setCountdown()
        this.$sensors.track('UM_Click_Verification_Code_Button')
        this.$api.usercenter.getAuthCodeCommon({ data })
      } else {
        this.$notify({ type: 'warning', message: '手机号/邮箱格式有误,请检查一下吧' })
      }
    },
    setCountdown () {
      this.countdownInterval = setInterval(() => {
        this.Countdown--
        if (this.Countdown <= 0) {
          clearInterval(this.countdownInterval)
        }
      }, 1000)
    }
  },
  watch: {}
}
</script>
<style lang="stylus" scoped>

.Verification{
  background-color #FFFFFF
  min-height 100vh
}
.head {
  position:relative;
  width: 100%;
  height: 100px;
  background: #ffffff;
  text-align: center;
}
.title {
  font-size: 36px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 100px;
}
.black_arrow {
  position: absolute;
  left: 30px;
  top: 50%;
  transform:translateY(-50%);
}
.EditingArea{
  width 622px
  padding-top 32px
  position relative
  margin-left -311px
  left 50%
  li {
    padding 1px 0
    height 122px
    overflow hidden
    border-bottom 1px solid #D7D7D7
    .passwordStyle{
      width 548px
      display inline-block
    }
  }
  .van-cell{
    padding 0
    height 58px
    line-height 58px
    font-size 18px
    background transparent
  }
}
li.authcodeInputWrapper{
  display flex
  align-items center
  justify-content space-between
}
.OperatingSpace{
  width 622px
  position relative
  margin-left -311px
  left 50%
  .van-button{
    width 100%
    height 44px
    line-height 44px
    margin-top 32px
    margin-bottom 24px
    span{
      color #FFFFFF
      font-size 16px
    }
  }
  .noneVanButton{
    background-color #C0D5FF
    border 1px solid #C0D5FF
  }
  .van-button--info{
    background-color linear-gradient(136deg, #227FFF 0%, #316FFF 100%)
    border 1px solid linear-gradient(136deg, #227FFF 0%, #316FFF 100%)
  }
}
.VerificationStyle{
  width 420px
}
.getVerificationStyle{
  color #333333
  font-size 30px
}
</style>
